import { Api_url } from "../../common/api_url";
import {
  API_XANO_AUTH_BASE_URL,
  API_XANO_BASE_URL,
} from "../../config/api_config";
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances";
import {
  EDIT_LAST_PLAYED,
  EDIT_LAST_PLAYED_COURSE,
  SET_AVAILABLE_COINS,
  SET_USER_ACTIVITY,
  SET_ENROLLED_SKILLS,
  EDIT_LAST_VISITED_SKILL,
  EDIT_LAST_VISITED_COURSE,
  EDIT_REDIRECT_TYPE,
  EDIT_LAST_VISITED_MSKILL_DETAILS,
  EDIT_LAST_VISITED_CERTIFICATE,
  SET_USER_DATA_FOR_BANNER,
  EDIT_LAST_VISITED_CONTENT,
  EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE,
  EDIT_PRICING_BANNER,
  SET_USER_CHALLENGE_DATA,
  EDIT_USER_CHALLENGE_DATA,
  ADD_EPS_SCORE,
  SET_WELCOME_MODAL_DISMISS,
  SET_IS_TRIAL_BLOCKED,
  SET_USER_COIN_ACTIVITY,
  SET_CONTINUE_LEARNING,
} from "./types";
import { getAllEnrolledMSkills } from "./skills";

export function enrollSkill(
  skill_slug,
  mskill_slug,
  userId,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.EnrollUserToSkill,
        {
          skill_slug: skill_slug,
          mskill_slug: mskill_slug,
          user_id: userId,
        }
      );

      successCallback &&
        dispatch(getAllEnrolledMSkills(userId, successCallback));
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserActivity(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetUserActivity,
        {
          params: {
            user_id,
          },
        }
      );

      dispatch({ type: SET_USER_ACTIVITY, payload: response.data });
      // console.log(response.data);
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function earnUserCoins(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_AUTH_BASE_URL + Api_url.EditCoins,
        {
          user_id,
          coin_amount: 3,
          is_school_credit: false,
        }
      );

      dispatch({
        type: SET_AVAILABLE_COINS,
        payload: response.data["available-coins"],
      });
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastPlayed(
  user_id,
  lesson_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditLastPlayed, {
        user_id: user_id,
        lesson_id: lesson_id,
      });
      dispatch({ type: EDIT_LAST_PLAYED, payload: lesson_id });
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function requestNewCourse(data, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        `https://xgfy-czuw-092q.m2.xano.io/api:D-e0IV7T/course_request`,
        data
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserCoinsTally(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetPointsTally,
        {
          params: {
            user_id,
          },
        }
      );
      // console.log(response.data)
      dispatch({ type: SET_USER_COIN_ACTIVITY, payload: response.data });
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getYoutubeRemarks(user_id, videoLink, successCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.YoutubeRemarks,
        {
          params: {
            user_id,
            videoLink,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
    }
  };
}

export function addYoutubeRemarks(user_id, videoLink, iconState) {
  return async function (dispatch) {
    try {
      await axiosAuth.post(API_XANO_BASE_URL + Api_url.YoutubeRemarks, {
        user_id,
        videoLink,
        like: iconState.like,
        dislike: iconState.dislike,
        flag: iconState.flag,
        bookmark: iconState.bookmark,
      });
    } catch (err) {
      console.log(err);
    }
  };
}

export function addVideoSuggestion(
  user_id,
  videoLink,
  report_reason,
  suggested_replacement = "",
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.VideoEditSuggestion,
        {
          user_id,
          videoLink,
          report_reason,
          suggested_replacement,
        }
      );

      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
    }
  };
}

export function addQuizSuggestion(
  user_id,
  lesson_id,
  quiz_id,
  report_comment,
  report_suggested_question = "",
  report_suggested_option_1 = "",
  report_suggested_option_2 = "",
  report_suggested_option_3 = "",
  report_suggested_option_4 = "",
  successCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.ReportQuizSuggestions,
        {
          user_id,
          lesson_id,
          quiz_id,
          report_comment,
          report_suggested_question,
          report_suggested_option_1,
          report_suggested_option_2,
          report_suggested_option_3,
          report_suggested_option_4,
        }
      );

      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
    }
  };
}

export function editLastPlayedCourse(
  course_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_PLAYED_COURSE, payload: course_id });
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserSearchedRecommendations(
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetUserSearchRecommendations,
        {
          params: {
            user_id,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastVisitedSkill(url_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_VISITED_SKILL, payload: url_slug });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastVisitedCourse(
  course_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_VISITED_COURSE, payload: course_slug });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editRedirectType(type, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_REDIRECT_TYPE, payload: type });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastVisitedMicroskill(
  details,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_VISITED_MSKILL_DETAILS, payload: details });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastVisitedCertificate(
  details,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_VISITED_CERTIFICATE, payload: details });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastVisitedContent(
  details,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_VISITED_CONTENT, payload: details });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editLastUnlockedCertificateImage(
  img,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE, payload: img });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function getLessonAndChallengeData(
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      //TODO figure out api and response
      // dispatch({ type: SET_USER_DATA_FOR_BANNER, payload: params: {user_id} })
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editPricingBanner(status, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: EDIT_PRICING_BANNER, payload: status });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function addChallengeToStore(data, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: SET_USER_CHALLENGE_DATA, payload: data });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function editOneDayChallenge(
  data,
  type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.EditChallengeStatus,
        {
          challenge_id: data?.id,
          is_extended: type,
        }
      );

      dispatch({ type: EDIT_USER_CHALLENGE_DATA, payload: data });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function getDiscountByActivity(
  user_id,
  activity_type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetDiscountByActivity,
        {
          params: {
            user_id,
            activity_type,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function getWebinarData(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetWebinars,
        {
          params: {
            user_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function subscribeToWebinar(
  broadcast_id,
  webinar_id,
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.SubscribeToWebinar,
        {
          user_id,
          broadcast_id,
          webinar_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function setEpsData(data, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: ADD_EPS_SCORE, payload: data });
      successCallback && successCallback();
    } catch (err) {
      errorCallback && errorCallback(err);
    }
  };
}

export function getAvailableJobs(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetAvailableJobs,
        {
          params: user_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function requestedJob(
  user_id,
  available_jobs_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.RequestJob,
        {
          user_id,
          available_jobs_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function welcomeModalDismiss(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      dispatch({ type: SET_WELCOME_MODAL_DISMISS, payload: true });
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function downgradeAccount(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_AUTH_BASE_URL + Api_url.DowngradeAccount
      );

      successCallback && successCallback(response.data);
      dispatch({ type: SET_IS_TRIAL_BLOCKED, payload: false });
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getWeeklyLeaderboardData(
  user_id,
  return_type,
  activity_type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.getLeaderboardData,
        {
          headers: {
            "cache-control": "no-cache",
          },
          params: {
            user_id,
            return_type,
            activity_type,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getWeeklyLeaderboardPerPage(
  user_id,
  return_type,
  page,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + ":v1" + Api_url.GetLeaderboardDataPerPage,
        {
          params: {
            user_id,
            return_type,
            page,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

// export function getHighestDiscount(user_id, successCallback, errorCallback) {
//     return async function (dispatch) {
//         try {

//             const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditChallengeStatus, {
//                 user_id
//             })

//             successCallback && successCallback(response.data)

//         } catch (err) {
//             errorCallback && errorCallback(err)
//         }
//     }
// }

export function getMicroSKillCompletionList(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetMicroSKillCompletedList
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);

      errorCallback && errorCallback(err);
    }
  };
}

export function onboardingSearch(search, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetSearchOnboarding,
        {
          params: {
            search,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getGoalsAndRoles(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url?.GetGoalsAndRoles
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getLastPlayedLesson(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url?.GetLastPlayedLesson
      );
      console.log("this is last played lesson", response.data);
      dispatch({ type: SET_CONTINUE_LEARNING, payload: response.data });
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function trackUserShare(share_uuid, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:lt_share/track",
        {
          share_uuid,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function trackVisitor(
  certificate_id,
  certificate_id_type,
  visitor_name,
  visitor_email,
  visitor_role,
  visitor_role_data,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:certificate/track/visitors/new",
        {
          certificate_id,
          certificate_id_type,
          visitor_name,
          visitor_email,
          visitor_role,
          visitor_role_data,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function RoadmapGenerator(
  employment_status,
  education_current_degree,
  education_stream,
  immediate_career_goal,
  current_job_role,
  roadmap_goal,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/new",
        {
          roadmap_title: "",
          employment_status,
          education_current_degree,
          education_stream,
          immediate_career_goal,
          current_job_role,
          roadmap_goal,
          is_collab: false,
          roadmap_feedback: "",
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function RoadmapGenerationStatus(
  user_roadmap_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/generation_status",
        {
          params: {
            user_roadmap_id,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function GetCurrentRoadMap(
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/current"
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function getRoadmapById(user_roadmap_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap", {
        params: {
          user_roadmap_id
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}
export function reportRoadmapCourse(user_roadmap_course_id, report_reason, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_courses/report", {
        params: {
          user_roadmap_course_id,
          report_reason
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function addRoadmapCourse(user_roadmap_id, course_name, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_courses/add_course", {

        user_roadmap_id,
        course_name

      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function removeRoadmapCourse(user_roadmap_course_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_courses/remove_course", {
        params: {
          user_roadmap_course_id,
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}



export function getPlacementServices(user_roadmap_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/placement_services", {
        params: {
          user_roadmap_id,
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addPlacementService(user_roadmap_id, placement_service, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_placement_services/add_service", {
        params: {

          user_roadmap_id,
          placement_service
        }

      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function removePlacementServices(user_roadmap_placement_services_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_placement_services/remove_service", {
        params: {
          user_roadmap_placement_services_id,
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function reportAndChangeRoadmap(user_roadmap_id, roadmap_feedback, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/change_roadmap", {
        user_roadmap_id,
        roadmap_feedback
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function publishRoadmap(user_roadmap_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/publish", {
        user_roadmap_id,
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getRoadmapRoles(user_roadmap_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap/related_job_roles", {
        params: {
          user_roadmap_id,
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function markCompletePlacementServices(user_roadmap_placement_services_id, reason_for_completion, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_placement_services/mark_complete", {
        params: {
          user_roadmap_placement_services_id, reason_for_completion
        }
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function getFriendActivity(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/user_friends/activity/learning_mskills"
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function getUserHasMobile(test_subject, user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:KuSR8Gl1/user_roadmap_courses/initiate_mobile_test", {
        test_subject,
        user_id
      }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function academyComplimentaryCourseOnboarding({
  user_id,
  name,
  skill_name,
  email,
  is_bundle,
  bundle_courses,
  phone_number,
  is_onboarding,
  successCallback,
  errorCallback
}) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/academy_complimentary_course_onboarding",
        {
          user_id,
          name,
          skill_name,
          email,
          is_bundle,
          bundle_courses,
          phone_number,
          is_onboarding,
        }
      );
      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function userAuthenticate(email, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/user_authenticate",
        {
          user_email: email,
        }
      );
      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function checkIfCourseUnlocked(
  user_id,
  courseNames,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    const maxAttempts = 30;
    const interval = 5000;
    let attempts = 0;
    let pollingTimeout = null;

    const pollCourseStatus = async () => {
      try {
        attempts++;

        const response = await axiosNoAuth.post(
          "https://ninjacurate.learntube.ai/check_if_course_unlocked",
          {
            user_id: user_id,
            courses: courseNames,
          }
        );

        const resData = response?.data;

        if (resData?.is_course_unlocked === true) {
          if (pollingTimeout) {
            clearTimeout(pollingTimeout);
          }
          successCallback && successCallback({ success: true, data: resData });
          return;
        }

        if (attempts < maxAttempts) {
          pollingTimeout = setTimeout(pollCourseStatus, interval);
        } else {
          errorCallback &&
            errorCallback({ success: false, data: resData });
        }
      } catch (err) {
        if (pollingTimeout) {
          clearTimeout(pollingTimeout);
        }
        console.log(err);
        errorCallback && errorCallback(err);
      }
    };

    pollCourseStatus();
  };
}

export function getAddonCourseBundleSyllabus(
  subject,
  goal,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/addon_course_bundle_syllabus",
        {
          subject,
          goal,
        }
      );
      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}



export function getAllPersonaliseCourseNames(
  uid,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/fetch_user_course_names",
        { uid },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      successCallback && successCallback(response?.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCertifiedToken(
  certified_user_skill_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {

    try {
      const response = await axiosNoAuth.get(
        "https://certified-new.learntube.ai/certified_user_skill/wa_token_test",
        {
          params: {
            certified_user_skill_id,
          },
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZXJ0aWZpZWRfdXNlcl9za2lsbF9pZCI6MzEyNDc4MiwiZXhwIjoxNzkzODM0ODkyfQ.qka8NuO-Uw4LJgiTXYRfEE6Y8mIHOWASIF2O5TM3edo`
          }
        }
      );

      successCallback && successCallback(response.data);


    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


